module.exports = __webpack_public_path__ + "static/media/kredyt_29.631ed874.png";